import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { Cart } from '~/src/features/videocontrol/pageBlocks/Cart';
import StepsInstall from '~/src/features/videocontrol/pageBlocks/StepsInstall';
import { Provider } from '~/src/features/videocontrol/Provider';
import { TState } from '~/src/store';
import { selectIsAuth } from '~/src/store/selectors/auth/selectIsAuth';
import { selectDomain } from '~/src/store/selectors/domain';

import Advantages from './pageBlocks/Advantages';
import Features from './pageBlocks/Features';
import Header from './pageBlocks/Header';
import { Questions } from './pageBlocks/Questions';
import { faqData } from './data';

import * as ST from './styled';

const Videocontrol = (): JSX.Element => {
    const videocontrolRef = useRef<HTMLHeadingElement | null>(null);
    const { clientPersonal, domain, isAuth } = useSelector((state: TState) => ({
        clientPersonal: state.auth.clientPersonal,
        domain: selectDomain(state),
        isAuth: selectIsAuth(state),
    }));

    return (
        <div>
            <ST.WrapperMain>
                <ST.SWideContainerHeader
                    webpImg={require('~/static/images/videocontrol/header/background.webp')}
                    pngImg={require('~/static/images/videocontrol/header/background.png')}
                >
                    <ST.SWideContainer>
                        <ST.BlockWrapper>
                            <Header videocontrolRef={videocontrolRef}/>
                        </ST.BlockWrapper>
                    </ST.SWideContainer>
                    <ST.SWideContainer>
                        <ST.BlockWrapper>
                            <ST.BlockTitle>Проверяйте, как дела дома с экрана смартфона</ST.BlockTitle>
                            <Advantages/>
                        </ST.BlockWrapper>
                    </ST.SWideContainer>
                </ST.SWideContainerHeader>
            </ST.WrapperMain>
            <ST.WrapperMainGray>
                <ST.SWideContainer>
                    <ST.BlockWrapper>
                        <ST.BlockTitle>Видеонаблюдение от Дом.ру – безопасность с умом</ST.BlockTitle>
                        <Features videocontrolRef={videocontrolRef}/>
                    </ST.BlockWrapper>
                </ST.SWideContainer>
            </ST.WrapperMainGray>
            <Provider>
                <ST.SWideContainer>
                    <StepsInstall domain={domain} ref={videocontrolRef}/>
                </ST.SWideContainer>
                <ST.CartWrapper>
                    <ST.SWideContainer>
                        <Cart
                            isAuth={isAuth}
                            agreement={clientPersonal?.agreement}
                        />
                    </ST.SWideContainer>
                </ST.CartWrapper>
            </Provider>
            <ST.WrapperMain>
                <ST.SWideContainer>
                    <ST.BlockWrapper>
                        <Questions
                            title={<ST.BlockTitle>Частые вопросы</ST.BlockTitle>}
                            questions={faqData}
                        />
                    </ST.BlockWrapper>
                </ST.SWideContainer>
            </ST.WrapperMain>
        </div>
    );
};

export default Videocontrol;
